import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { removeOrganisationsSwitch } from '@api/organisationSwitch';

import { IId } from '@interfaces/common/common';

import { ORGANISATIONS, ORGANIZATIONS_SWITCH } from '@constants/queryKeys';

interface IUseMutateRemoveOrganisationSwitch {
	removeOrganisationSwitch: UseMutateFunction<any, any, IId, any>;
	isLoadingRemoveOrganisationSwitch: boolean;
}

export const useMutateRemoveOrganisationSwitch = (): IUseMutateRemoveOrganisationSwitch => {
	const queryClient = useQueryClient();

	const {
		mutate: removeOrganisationSwitch,
		isLoading: isLoadingRemoveOrganisationSwitch,
	} = useMutation<IId>({
		mutationKey: [ORGANISATIONS],
		mutationFn: removeOrganisationsSwitch,
		onSuccess: () => {
			return queryClient.invalidateQueries([ORGANIZATIONS_SWITCH]);
		},
	});

	return {
		removeOrganisationSwitch,
		isLoadingRemoveOrganisationSwitch,
	};
};
